<script>
    import {PATH_PREFIX} from '../../apiUrls.js';

    import {getContext} from 'svelte';
    import DataTable from '../DataGrid/DataTable.svelte';
    import ConfirmationModal from '../ConfirmationModal.svelte';
    import TextColumn from '../DataGrid/ColumnRenderers/TextColumn.svelte';
    import NumberColumn from '../DataGrid/ColumnRenderers/NumberColumn.svelte';
    import ElementMediaInputColumn from '../DataGrid/ColumnRenderers/ElementMediaInputColumn.svelte';
    import {submit} from '../../utils.js';
    import {validateForm} from '../Form/utils.js';
    import {sgettext} from '../../i18n.js';
    import yup from 'yup';
    import Button from '../Button.svelte';
    import {ElementVersionEntity} from './constants.js';
    import Errors from '../Errors.svelte';
    import Thumbnail from '../common/Media/Thumbnail.svelte';


    export let rows = [];
    export let elementVersionId = 0;
    export let elementId = 0;
    export let eevId = 0;
    $: collapseId = `tools-editor-${elementVersionId}`;

    let actionUrl = `${PATH_PREFIX}/sw/api/elements_database/tools/`;
    let toolsMediaUploadUrl = `${PATH_PREFIX}/sw/api/elements_database/tools/element_version_tools_media_upload/`;
    let reorderApiUrl = `${PATH_PREFIX}/sw/api/elements_database/elementversions/${elementVersionId}/reorder_tools/`;
    let deleteMediaUrl = `${PATH_PREFIX}/sw/api/elements_database/tools/${elementVersionId}/element_version_tools_media_delete/`; //The endpoint seems to actually ignore the <pk> for some reason

    let showDeleteConfirmation = false;
    let selectedItem = null;
    let deleting = false;
    let saving = false;
    let deleteConfirmationId = 'deleteToolConfirmation';
    let deleteMediaConfirmationId = 'deleteMediaToolId';

    let errors = null;
    let bgColor = '#EDF1F2';
    let showCreateNew = true;
    let current_row = [];

    const schema = yup.object().shape({
        tool_description: yup.string()
            .required(sgettext('$$REQUIRED_FIELD$$')),
        quantity: yup.number()
            .required(sgettext('$$REQUIRED_FIELD$$'))
            .min(1, sgettext('$$QUANTITY_MUST_GREATER_0_1$$'))
            .typeError(sgettext('$$REQUIRED_FIELD$$')),
        specification: yup.string()
            .required(sgettext('$$REQUIRED_FIELD$$')),
    });

    const {showMarkerModal} = getContext('showMarkerModal');
    const {showMarkerRemovalConfirmationModal} = getContext('showMarkerRemovalConfirmationModal');

    $: data = rows.map(r => ({...r, fieldValidations: initialFieldValidations()}));
    $: showCreateNew = rows.find(r => !r.id) ? false : true;

    let columns = {
        element_slide: {
            label: sgettext('$$IMAGE$$'),
            renderer: ElementMediaInputColumn,
            width: '160px',
            props: {
                onRemove: showMediaDeleteModal,
                onChange: handleMediaChange,
                allowRemove: true,
                useMarkUp: true,
                useMediaLibrary: true,
                mediaLibraryId: 'elementMediaLibrary',
                entity: ElementVersionEntity.tool,
                onShowMarker: showMarkerModal,
                onRemoveMarkup: showMarkerRemovalConfirmationModal,
            }
        },
        tool_description: {
            label: sgettext('$$TOOL$$'),
            renderer: TextColumn,
            props: {
                onChange: handleRowChange
            }
        },
        quantity: {
            label: sgettext('$$QUANTITY$$'),
            renderer: NumberColumn,
            width: '90px',
            props: {
                onChange: handleRowChange,
                min: 1,
                max: 9999
            }
        },
        specification: {
            label: sgettext('$$SPECIFICATION$$'),
            renderer: TextColumn,
            props: {
                onChange: handleRowChange
            }
        }
    }

    let rowActions = {
        remove: {
            iconClass: 'fas fa5-trash-alt',
            handler: (event, tool) => {
                selectedItem = tool;
                toggleModal('show');
            }
        }
    }

    let newRowActions = {
        add: {
            key: 'save',
            label: sgettext('$$ADD_1$$'),
            width: '100px',
            btnClass: 'outline-primary',
            handler: async (event, item) => {
                await saveItem(item);
            }
        },
        cancel: {
            label: sgettext('$$CANCEL$$'),
            width: '100px',
            btnClass: 'outline-secondary',
            handler: (event, item) => {
                selectedItem = item;
                showCreateNew = true;
                handleRemove();
            }
        }
    }

    async function showMediaDeleteModal(event, row) {
        current_row = row
        toggleMediaDeleteModal('show')
    }


    async function handleMediaChange(media, row) {
        if (media && row && row.id) {
            const formData = new FormData();
            formData.append('media', media);
            formData.append('tool_id', row.id);
            formData.append('eev_id', eevId);

            errors = null;

            const resp = await submit(toolsMediaUploadUrl, 'POST', formData, null, true);
            if (resp.ok) {
                const json = await resp.json();
                json.fieldValidations = initialFieldValidations();
                const unsorted = [...data.filter(r => r.id !== json.id), json]; // refresh data with newly saved row
                data = unsorted.sort((a, b) => a.sequence - b.sequence);
                rows = [...data];
            } else {
                errors = await resp.json();
            }
        }
    }

    function initialFieldValidations() {
        return {
            tool_description: {
                isValid: true,
                errors: ''
            },
            quantity: {
                isValid: true,
                errors: ''
            },
            specification: {
                isValid: true,
                errors: ''
            }
        };
    }

    async function handleRemove() {
        if (selectedItem) {
            deleting = true;
            if (selectedItem.id) {
                const url = `${actionUrl}${selectedItem.id}/`;
                const resp = await submit(url, 'DELETE');

                if (resp.ok) {
                    data = data.filter(r => r.id !== selectedItem.id);
                    toggleModal('hide');
                    selectedItem = null;
                    rows = [...data];
                }
            } else {
                data = data.filter(r => r.id);
                toggleModal('hide');
                rows = [...data];
            }

            deleting = false;
        }
    }

    function toggleModal(state) {
        jQuery(`#${deleteConfirmationId}`).modal(state);
    }

    function toggleMediaDeleteModal(state) {
        jQuery(`#${deleteMediaConfirmationId}`).modal(state);
    }


    async function handleRemoveMedia(row) {
        toggleMediaDeleteModal('hide');
        const url = deleteMediaUrl;
        const formData = new FormData();
        formData.append('tool_id', row.id);

        errors = null;
        current_row.element_slide = null


        const resp = await submit(url, 'POST', formData, null, true);
        if (resp.ok) {
            let json = await resp.json();
            json.fieldValidations = initialFieldValidations();
            const unsorted = [...data.filter(r => r.id !== json.id)]; // refresh data with newly saved row
            data = unsorted.sort((a, b) => a.sequence - b.sequence);
            rows = [...data];
        } else {
            errors = await resp.json();
        }
    }


    function handleRowChange(event, row) {
        if (row.id) {
            saveItem(row);
        }
    }

    function cancelDeleteTool() {
        toggleModal('hide');
        showDeleteConfirmation = false;
    }

    function cancelMediaDeleteTool() {
        toggleMediaDeleteModal('hide');
    }


    function getNextSequence() {
        let next = 1;

        if (data.length === 1) {
            next = data[0].sequence + 1;
        } else if (data.length > 1) {
            const sorted = data.slice().sort((a, b) => b.sequence - a.sequence);
            if (sorted.length > 1) {
                next = sorted[0].sequence + 1;
            }
        }

        return next;
    }

    async function createNewToolWithImage(payload) {
        const formData = new FormData();
        if (!payload.element_slide.element_media_id) {
            formData.append('media', payload.element_slide);
        } else {
            formData.append('element_media_id', payload.element_slide.element_media_id);
        }
        formData.append('tool_description', payload.tool_description);
        formData.append('quantity', payload.quantity);
        formData.append('specification', payload.specification);
        formData.append('element_id', elementId);
        formData.append('element_version', elementVersionId);
        formData.append('sequence', payload.sequence);


        return await submit(`${actionUrl}new_with_media/`, 'POST', formData, null, true);
    }

    async function saveItem(payload) {
        let resp = {};

        try {
            errors = null;
            await validateForm(schema, payload);
            saving = true;

            if (payload.id) {
                const url = `${actionUrl}${payload.id}/`;
                resp = await submit(url, 'PATCH', payload);
            } else {
                if (payload.element_slide) {
                    resp = await createNewToolWithImage(payload);
                } else {
                    resp = await submit(actionUrl, 'POST', payload);
                }
            }

            if (resp.ok) {
                const json = await resp.json();
                let tools = data.filter(t => t.id);
                json.fieldValidations = initialFieldValidations();
                payload.fieldValidations = initialFieldValidations();
                if (!payload.id) {
                    data = [...tools, json];
                } else {
                    data = tools;
                }

                if (!payload.id) {
                    handleCreateNew();
                }
                rows = [...data];
            } else {
                errors = await resp.json();
            }
        } catch (err) {
            if (err.inner) {
                err.inner.forEach((er) => {
                    payload.fieldValidations[er.path].isValid = false;
                    payload.fieldValidations[er.path].errors = er.message;
                });
                data = [...data];
            }
        } finally {
            saving = false;
            const newRow = data.find(r => !r.id);
            if (!newRow) {
                showCreateNew = true;
            }
        }
    }

    function createNewItem() {
        return {
            quantity: 1,
            sequence: getNextSequence(),
            tool_description: '',
            specification: '',
            element_version: elementVersionId,
            fieldValidations: initialFieldValidations(),
            rowActions: newRowActions
        };
    }


    function handleCreateNew() {
        data = [...data, createNewItem()];
        showCreateNew = false;
    }

    async function handleRowReordered(event) {
        const payload = event.detail.rows.filter(r => r.id).map(r => ({id: r.id, sequence: r.sequence}));
        const resp = await submit(reorderApiUrl, 'PATCH', {items: payload});

        if (resp.ok) {
            const json = await resp.json();
            data = json.map(r => ({...r, fieldValidations: initialFieldValidations()}));
            rows = [...data];
        }
    }

</script>

<style>
    .wrapper {
        margin-bottom: 15px;
    }

    .actions {
        margin-top: 15px;
        display: flex;
        justify-content: flex-end;
    }
</style>

<div class="wrapper">
    <DataTable
        {columns}
        rows={data}
        {rowActions}
        {schema}
        dragMode="bodyRow"
        sortFunction={(a, b) => a.sequence - b.sequence}
        on:reordered={handleRowReordered}
        {bgColor}
        {saving}
    />
    <Errors {errors}/>

    {#if showCreateNew}
        <div class="actions d-flex flex-nowrap justify-content-end">
            <button class="btn btn-outline-primary" role="button" on:click={handleCreateNew}>
                {sgettext('$$CREATE_NEW_1$$')}
            </button>
        </div>
    {/if}
</div>


<ConfirmationModal
    id={deleteConfirmationId}
    title="{sgettext('$$DELETE_CONFIRMATION$$')}"
    onYes={handleRemove}
    onNo={cancelDeleteTool}
    sending={deleting}>
    <div slot="message">
        <p>{sgettext('$$SURE_WANT_DELETE_TOOL$$')}</p>
        {#if selectedItem}
            {#if selectedItem.tool_description}
                <div>{selectedItem.tool_description}</div>
            {/if}
            {#if selectedItem.specification}
                <div>{selectedItem.specification}</div>
            {/if}
        {/if}
        <br/>
    </div>
</ConfirmationModal>


<ConfirmationModal
    id={deleteMediaConfirmationId}
    title="{sgettext('$$DELETE_CONFIRMATION$$')}"
    onYes={handleRemoveMedia}
    onNo={cancelMediaDeleteTool}
    sending={deleting}
    data={current_row}
>
    <div slot="message">
        <p>{sgettext('$$SURE_WANT_DELETE_MEDIA_1$$')}</p>
        {#if current_row && current_row.element_slide}
            <Thumbnail
                url={current_row.element_slide.thumbnail}
                media={current_row.element_slide.url}
                type={current_row.element_slide.type}
            />
        {/if}
    </div>

</ConfirmationModal>
